module.exports = __webpack_public_path__ + "img/badminton.fdb48d4b.jpg";